// A05展示字段不决定资格、次数、冻结金额或申请凭证。
export function legacySignImageUrl(value) {
  if (typeof value !== 'string') return '';
  const text = value.trim();
  if (!text || /[\s\u0000-\u001f\u007f\\]/.test(text) || text.startsWith('//')) return '';
  if (text.startsWith('/')) return text;
  try {
    const url = new URL(text);
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password ? text : '';
  } catch { return ''; }
}

export function legacySignImages(values) {
  return Array.isArray(values) ? values.map(legacySignImageUrl).filter(Boolean).slice(0, 10) : [];
}

export function legacySignPresentation(activity) {
  const value = activity?.activityType === 'WEEK_SIGN_IN' && activity.legacySignPresentation;
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  return {
    title: typeof value.title === 'string' ? value.title.trim() : '',
    notSignImageUrl: legacySignImageUrl(value.notSignImageUrl),
    canSignImageUrl: legacySignImageUrl(value.canSignImageUrl),
    alreadySignImageUrl: legacySignImageUrl(value.alreadySignImageUrl),
    fullGifts: (Array.isArray(value.fullGifts) ? value.fullGifts : [])
      .filter(gift => Number.isSafeInteger(gift?.level) && gift.level > 0 && typeof gift.prizeName === 'string' && gift.prizeName.trim())
      .map(gift => ({ level: gift.level, requiredBet: typeof gift.requiredBet === 'string' ? gift.requiredBet : '', prizeName: gift.prizeName,
        imageUrls: legacySignImages(gift.imageUrls), attribute: typeof gift.attribute === 'string' ? gift.attribute : '' }))
  };
}

// 已签到图仅表示凭证存在；待领/待审/拒绝状态继续由独立文字显示。
export function legacySignDayImage(presentation, day, canSign) {
  if (!presentation) return '';
  return legacySignImageUrl(day?.state === 'signed' ? presentation.alreadySignImageUrl
    : day?.current === true && canSign === true ? presentation.canSignImageUrl : presentation.notSignImageUrl);
}
